import { URL } from 'api/urls';

import {
	IRUConfigurationsDTO,
	IUpdateRUConfigurationsDTO,
} from '@interfaces/cmModule/dto/ruConfigurationsDTO';
import { IRUConfiguration } from '@interfaces/cmModule/ruConfiguration';
import { TIdSystemId, TNameTitle, TNameTitleColor } from '@interfaces/common/common';
import { IItemsResponse } from '@interfaces/common/response';
import { IUserListResponse } from '@interfaces/user/user';

import { client } from './client';

export const getRUConfigurations = (dto: IRUConfigurationsDTO): Promise<IItemsResponse<IRUConfiguration>> => {
	return client.get(`${URL.ruConfiguration}/filter`, { params: dto });
};

export const getRUConfigurationMiddlewares = (): Promise<TIdSystemId[]> => {
	return client.get(`${URL.ruConfiguration}/middlewares`);
};

export const getRUConfigurationStatuses = (): Promise<TNameTitleColor[]> => {
	return client.get(`${URL.ruConfiguration}/statuses`);
};

export const getRUConfigurationConfigs = (): Promise<TNameTitle[]> => {
	return client.get(`${URL.ruConfiguration}/configured-statuses`);
};

export const getRUConfigurationNetconfs = (): Promise<TNameTitle[]> => {
	return client.get(`${URL.ruConfiguration}/netconf-apply-results`);
};

export const getRUConfigurationUsers = (): Promise<IUserListResponse[]> => {
	return client.get(`${URL.ruConfiguration}/users`);
};

export const updateRUConfiguration = ({ id, ...dto }: IUpdateRUConfigurationsDTO): Promise<void> => {
	return client.post(`${URL.ruConfiguration}/${id}/update`, dto);
};
